// src/utils/getLang.ts
export const languageMap: Record<string, string> = {
  en: "en",
  "zh-CN": "zh_CN",
  "zh-TW": "zh_TW",
  zh_CN: "zh_CN",
  zh_TW: "zh_TW",
  th: "th",
  id: "in_ID", // 浏览器获取到是id， 后端是in_ID
  in_ID: "in_ID", // 浏览器获取到是id， 后端是in_ID
  ms: "ms",
  vi: "vi",
  ar: "ar",
  "ar-SA": "ar",
  "ar-EG": "ar",
  es: "es",
  "es-ES": "es",
  fr: "fr",
  pt: "pt",
  "pt-BR": "pt",
  ru: "ru",
  tr: "tr",
  "tr-TR": "tr",
};
export const languageName: Record<string, string> = {
  en: "EN",
  zh_CN: "ZH",
  zh_TW: "ZH",
  th: "TH",
  in_ID: "ID", // 浏览器获取到是id， 后端是in_ID
  ms: "MS",
  vi: "VI",
  ar: "AR",
  tr: "TR",
  es: "ES",
  fr: "FR",
  pt: "PT",
  ru: "RU",
};

export function getLang(query?: any) {
  // 服务端
  if (typeof window === "undefined") {
    console.log("query");
    console.log("lang===", query?.lang, "language===", query?.language);
    // Next.js getServerSideProps 传入的 context
    if (query?.lang) return query.lang;
    if (query?.language) return query.language;
    return "en"; // 默认
  }

  // 客户端
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get("lang") || urlParams.get("language");
  if (urlLang) return urlLang;

  // 兼容 query 里的 lang/language
  if (query?.lang) return query.lang;
  if (query?.language) return query.language;

  // 浏览器语言
  const browserLang = navigator.language || (navigator as any).userLanguage;

  if (browserLang) {
    //   // 你可以根据需要做映射
    //   if (browserLang.toLowerCase().startsWith("zh")) return "zh_CN";
    //   if (browserLang.toLowerCase().startsWith("en")) return "en_US";
    //   // ...其他映射
    return languageMap[browserLang] || languageMap["en"];
  }
  return "en";
}
